/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ScoreInputs */

const en_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score`)
};

const es_score = /** @type {(inputs: ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntaje`)
};

/**
* | output |
* | --- |
* | "Score" |
*
* @param {ScoreInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const score = /** @type {((inputs?: ScoreInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ScoreInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_score(inputs)
	return es_score(inputs)
});